import type { RespondentFilterUsingMetaGroupsProps } from './RespondentFilterUsingMetaGroups';
import type { FilterMode } from './RespondentFilterSettings';
import type { ResultFilter } from './__generated__/RespondentFilterUsingMetaResultsQuery.graphql';

type MetaGroups = RespondentFilterUsingMetaGroupsProps['metaGroups'];

/**
 * Filter meta groups
 */
export function filterMetaGroups(
    metaGroups: MetaGroups,
    filters: ReadonlyArray<ResultFilter>,
    filterMode: FilterMode,
): RespondentFilterUsingMetaGroupsProps['metaGroups'] {
    switch (filterMode) {
        case 'LogicalAnd':
            return logicalAndFilter(metaGroups, filters);
        case 'LogicalOr':
            return logicalOrFilter(metaGroups, filters);
    }
}

function logicalAndFilter(
    metaGroups: MetaGroups,
    filters: ReadonlyArray<ResultFilter>,
): MetaGroups {
    return filters.reduce(
        (filteredMetaGroups, filter) =>
            filteredMetaGroups.filter(({ metaQuestionResponses }) =>
                metaQuestionResponses.some(
                    (metaQuestionResponse) =>
                        filter.metaKey ===
                            metaQuestionResponse.metaQuestionId &&
                        filter.metaValues.includes(
                            metaQuestionResponse.responseOptionValue.toString(),
                        ),
                ),
            ),
        metaGroups,
    );
}

function logicalOrFilter(
    metaGroups: MetaGroups,
    filters: ReadonlyArray<ResultFilter>,
): MetaGroups {
    if (filters.length === 0) {
        return metaGroups;
    }
    return metaGroups.filter((metaGroup) =>
        filters.some((filter) =>
            metaGroup.metaQuestionResponses.some(
                (metaQuestionResponse) =>
                    filter.metaKey === metaQuestionResponse.metaQuestionId &&
                    filter.metaValues.includes(
                        metaQuestionResponse.responseOptionValue.toString(),
                    ),
            ),
        ),
    );
}
